"use client";

import { LogoutBtn } from "./LogoutBtn";
import { logout } from "./logout.action";
export function LogoutForm() {
  return <form className="w-full" action={async () => {
    await logout();
    window.location.reload();
  }} data-sentry-component="LogoutForm" data-sentry-source-file="LogoutForm.tsx">
      <LogoutBtn data-sentry-element="LogoutBtn" data-sentry-source-file="LogoutForm.tsx" />
    </form>;
}